export const PICKUP = 'pickup';
export const DELIVERY = 'delivery';
